var _jsxFileName = "/repo/packages/webassets/src/components/Footer/FooterLinks/AnonFooterLinks.tsx",
  _this = this;
import React, { useContext } from 'react';
import { getAnonCategories } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';
var AnonFooterLinks = function AnonFooterLinks() {
  var _useContext = useContext(SMFooterContext),
    domain = _useContext.domain,
    lang = _useContext.lang,
    country = _useContext.country,
    variant = _useContext.variant,
    onetrustBannerEnabled = _useContext.onetrustBannerEnabled;
  var categories = getAnonCategories(domain, lang, country, variant);
  var margin = variant === 'slim';
  return /*#__PURE__*/React.createElement(React.Fragment, null, categories.map(function (category, i) {
    return /*#__PURE__*/React.createElement(InlineList, {
      key: category[0].title,
      noMargin: margin,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 9
      }
    }, category.map(function (item) {
      return /*#__PURE__*/React.createElement(InlineListItem, {
        href: item.url,
        anchorAttributes: item.anchorAttributes,
        key: item.title,
        isTitle: item.isTitle,
        lastItem: item.lastItem,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 13
        }
      }, item.title);
    }), i === 2 && !!onetrustBannerEnabled ? /*#__PURE__*/React.createElement(InlineListItem, {
      href: "#cookiePreferences",
      className: "ot-sdk-show-settings",
      "data-testid": "AnonFooterLinks__cookiePreferences",
      lastItem: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 13
      }
    }) : null);
  }));
};
export default AnonFooterLinks;
//# sourceMappingURL=AnonFooterLinks.js.map